import qr from '../../assets/icons/QR.svg';
import puntosVenta from '../../assets/icons/puntos-venta.svg';
import accessibilityOutline from '../../assets/icons/accessibility_outline.svg';
import aceleraciones from '../../assets/icons/aceleraciones.svg';
import {
  addAwardOutline,
  addAwardsOutline,
  addCircleDashedOutline,
  addCircleOutline,
  addOutline,
  addSquareOutline,
} from '../../assets/icons/AddIcon';
import advertisingOutline from '../../assets/icons/advertising_outline.svg';
import ahora12 from '../../assets/icons/ahora-12.svg';
import ahora12b from '../../assets/icons/ahora-12-b.svg';
import airplayAudioOutline from '../../assets/icons/airplay_audio_outline.svg';
import airplayVideoOutline from '../../assets/icons/airplay_video_outline.svg';
import allCategoriesOutline from '../../assets/icons/all_categories_outline.svg';
import anses from '../../assets/icons/anses.svg';
import appBadgeOutline from '../../assets/icons/app_badge_outline.svg';
import appleOutline from '../../assets/icons/apple_outline.svg';
import appleWatchOutlite from '../../assets/icons/apple_watch_outlite.svg';
import archiveOutline from '../../assets/icons/archive_outline.svg';
import armchairOutline from '../../assets/icons/armchair_outline.svg';
import {
  arrowDownOutline,
  arrowLeftOutline,
  arrowPopDownOutline,
  arrowPopUpOutline,
  arrowRightCircleOutline,
  arrowRightOutline,
  arrowRightSquareOutline,
  arrowUpCircleOutline,
  arrowUpOutline,
  arrowUpRectangleOutline,
  arrowUturnLeftOutline,
  arrowUturnRightOutline,
} from '../../assets/icons/ArrowIcon';
import articleOutline from '../../assets/icons/article_outline.svg';
import articlesOutline from '../../assets/icons/articles_outline.svg';
import attachOutline from '../../assets/icons/attach_outline.svg';
import babyBottleOutline from '../../assets/icons/baby_bottle_outline.svg';
import backspaceOutline from '../../assets/icons/backspace_outline.svg';
import ballOutline from '../../assets/icons/ball_outline.svg';
import bankOutline from '../../assets/icons/bank_outline.svg';
import basketballBallOutline from '../../assets/icons/basketball_ball_outline.svg';
import beautyOutline from '../../assets/icons/beauty_outline.svg';
import bidyOutline from '../../assets/icons/bidy_outline.svg';
import billheadOutline from '../../assets/icons/billhead_outline.svg';
import blockOutline from '../../assets/icons/block_outline.svg';
import bodyOutline from '../../assets/icons/body_outline.svg';
import bombOutline from '../../assets/icons/bomb_outline.svg';
import bookOutline from '../../assets/icons/book_outline.svg';
import bookmarkOutline from '../../assets/icons/bookmark_outline.svg';
import booksOutline from '../../assets/icons/books_outline.svg';
import botonDePago from '../../assets/icons/boton-de-pago.svg';
import bowlSticksOutline from '../../assets/icons/bowl_sticks_outline.svg';
import boxHeartOutline from '../../assets/icons/box_heart_outline.svg';
import brainOutline from '../../assets/icons/brain_outline.svg';
import briefcaseOutline from '../../assets/icons/briefcase_outline.svg';
import broadcastOutline from '../../assets/icons/broadcast_outline.svg';
import brushOutline from '../../assets/icons/brush_outline.svg';
import bugOutline from '../../assets/icons/bug_outline.svg';
import buildingOutline from '../../assets/icons/building_outline.svg';
import busOutline from '../../assets/icons/bus_outline.svg';
import cactusOutline from '../../assets/icons/cactus_outline.svg';
import { calendarOutline } from '../../assets/icons/Calendar';
import cameraOutline from '../../assets/icons/camera_outline.svg';
import cameraSlashOutline from '../../assets/icons/camera_slash_outline.svg';
import {
  cancelCircleOutline,
  cancelOutline,
  cancelShieldOutline,
} from '../../assets/icons/Cancel';
import canisterOutline from '../../assets/icons/canister_outline.svg';
import carOutline from '../../assets/icons/car_outline.svg';
import cards2Outline from '../../assets/icons/cards_2_outline.svg';
import cashOutOutline from '../../assets/icons/cash_out_outline.svg';
import chainOutline from '../../assets/icons/chain_outline.svg';
import checkCircleDeviceOutline from '../../assets/icons/check_circle_device_outline.svg';
import checkShieldDeviceOutline from '../../assets/icons/check_shield_device_outline.svg';
import checkShieldOutline from '../../assets/icons/check_shield_outline.svg';
import checkSquareOutline from '../../assets/icons/check_square_outline.svg';
import checksOutline from '../../assets/icons/checks_outline.svg';
import chefHatOutline from '../../assets/icons/chef_hat_outline.svg';
import {
  chevronDownOutline,
  chevronDownSmall,
  chevronLeftOutline,
  chevronRightOutline,
  chevronUpOutline,
  chevronUpSmall,
  chevrons2LeftOutline,
  chevrons2RightOutline,
} from '../../assets/icons/Chevron';
import chevronLeftSmall from '../../assets/icons/chevron_left_small.svg';
import chevronRightCircleOutline from '../../assets/icons/chevron_right_circle_outline.svg';
import chevronRightSmall from '../../assets/icons/chevron_right_small.svg';
import clearDataOutline from '../../assets/icons/clear_data_outline.svg';
import clipOutline from '../../assets/icons/clip_outline.svg';
import clockRectangleStackOutline from '../../assets/icons/clock_rectangle_stack_outline.svg';
import cobroAnticipado from '../../assets/icons/cobro-anticipado.svg';
import coffeeSteamOutline from '../../assets/icons/coffee_steam_outline.svg';
import colaboradores from '../../assets/icons/colaboradores.svg';
import commentDisableOutline from '../../assets/icons/comment_disable_outline.svg';
import commentOutline from '../../assets/icons/comment_outline.svg';
import compassOutline from '../../assets/icons/compass_outline.svg';
import computerOutline from '../../assets/icons/computer_outline.svg';
import conciliacion from '../../assets/icons/conciliacion.svg';
import configuracion from '../../assets/icons/configuracion.svg';
import contracargos1 from '../../assets/icons/contracargos-1.svg';
import contracargos from '../../assets/icons/contracargos.svg';
import cookieOutline from '../../assets/icons/cookie_outline.svg';
import { ReactComponent as copyOutline } from '../../assets/icons/copy_outline.svg';
import crop from '../../assets/icons/crop.svg';
import crownOutline from '../../assets/icons/crown_outline.svg';
import cubeBoxOutline from '../../assets/icons/cube_box_outline.svg';
import cupOutline from '../../assets/icons/cup_outline.svg';
import cuponesEnVuelo from '../../assets/icons/cupones-en-vuelo.svg';
import deleteArrowUpOutline from '../../assets/icons/delete_arrow_up_outline.svg';
import devicesOutline from '../../assets/icons/devices_outline.svg';
import diamondOutline from '../../assets/icons/diamond_outline.svg';
import dice1Outline from '../../assets/icons/dice_1_outline.svg';
import dice2Outline from '../../assets/icons/dice_2_outline.svg';
import dice3Outline from '../../assets/icons/dice_3_outline.svg';
import dice4Outline from '../../assets/icons/dice_4_outline.svg';
import dice5Outline from '../../assets/icons/dice_5_outline.svg';
import dice6Outline from '../../assets/icons/dice_6_outline.svg';
import discountOutline from '../../assets/icons/discount_outline.svg';
import dollarCircleOutline from '../../assets/icons/dollar_circle_outline.svg';
import donateOutline from '../../assets/icons/donate_outline.svg';
import doorArrowLeftOutline from '../../assets/icons/door_arrow_left_outline.svg';
import doorArrowRightOutline from '../../assets/icons/door_arrow_right_outline.svg';
import downloadCancelOutline from '../../assets/icons/download_cancel_outline.svg';
import downloadCheckOutline from '../../assets/icons/download_check_outline.svg';
import downloadCloudOutline from '../../assets/icons/download_cloud_outline.svg';
import drillOutline from '../../assets/icons/drill_outline.svg';
import educationOutline from '../../assets/icons/education_outline.svg';
import emblemOutline from '../../assets/icons/emblem_outline.svg';
import employeeOutline from '../../assets/icons/employee_outline.svg';
import {
  errorCircleOutline,
  errorCircleFilled,
} from '../../assets/icons/Error';
import explicitOutline from '../../assets/icons/explicit_outline.svg';
import externalLinkOutline from '../../assets/icons/external_link_outline.svg';
import faceIdOutline from '../../assets/icons/face_id_outline.svg';
import faceRecognitionOutline from '../../assets/icons/face_recognition_outline.svg';
import favorite from '../../assets/icons/favorite.svg';
import favoriteFilled from '../../assets/icons/favorite_filled.svg';
import favoriteOutline from '../../assets/icons/favorite_outline.svg';
import filmStripAddOutline from '../../assets/icons/film_strip_add_outline.svg';
import filmStripOutline from '../../assets/icons/film_strip_outline.svg';
import fireOutline from '../../assets/icons/fire_outline.svg';
import fortuneWheelOutline from '../../assets/icons/fortune_wheel_outline.svg';
import forward10Outline from '../../assets/icons/forward_10_outline.svg';
import gameOutline from '../../assets/icons/game_outline.svg';
import gestureOutline from '../../assets/icons/gesture_outline.svg';
import ghostOutline from '../../assets/icons/ghost_outline.svg';
import ghostSimleOutline from '../../assets/icons/ghost_simle_outline.svg';
import giftOutline from '../../assets/icons/gift_outline.svg';
import globeOutline from '../../assets/icons/globe_outline.svg';
import googlePlayOutline from '../../assets/icons/google_play_outline.svg';
import graphOutline from '../../assets/icons/graph_outline.svg';
import { calculatorOutline } from '../../assets/icons/Calculator';
import { gridLayoutOutline } from '../../assets/icons/Grid';
import gunOutline from '../../assets/icons/gun_outline.svg';
import hammerOutline from '../../assets/icons/hammer_outline.svg';
import handSlashOutline from '../../assets/icons/hand_slash_outline.svg';
import hangerOutline from '../../assets/icons/hanger_outline.svg';
import hashtagOutline from '../../assets/icons/hashtag_outline.svg';
import headphonesOutline from '../../assets/icons/headphones_outline.svg';
import healthOutline from '../../assets/icons/health_outline.svg';
import heartCircleOutline from '../../assets/icons/heart_circle_outline.svg';
import heartLockOutline from '../../assets/icons/heart_lock_outline.svg';
import heartUnlockOutline from '../../assets/icons/heart_unlock_outline.svg';
import { helpCircleOutline, helpOutline } from '../../assets/icons/Help';
import { hideOutline, viewOutline } from '../../assets/icons/viewIcon';
import historialBtnPago from '../../assets/icons/historial-btn-pago.svg';
import historial from '../../assets/icons/historial.svg';
import historyBackwardOutline1 from '../../assets/icons/history_backward_outline-1.svg';
import historyBackwardOutline from '../../assets/icons/history_backward_outline.svg';
import historyForwardOutline from '../../assets/icons/history_forward_outline.svg';
import homeHeartOutline from '../../assets/icons/home_heart_outline.svg';
import horseToyOutline from '../../assets/icons/horse_toy_outline.svg';
import imageFilterOutline from '../../assets/icons/image_filter_outline.svg';
import inboxOutline from '../../assets/icons/inbox_outline.svg';
import incognitoOutline from '../../assets/icons/incognito_outline.svg';
import informacion from '../../assets/icons/informacion.svg';
import inicio from '../../assets/icons/inicio.svg';
import insumoPapel from '../../assets/icons/insumo-papel.svg';
import ipadOutline from '../../assets/icons/ipad_outline.svg';
import keyOutline from '../../assets/icons/key_outline.svg';
import keySquareOutline from '../../assets/icons/key_square_outline.svg';
import keyboardBotsOutline from '../../assets/icons/keyboard_bots_outline.svg';
import keyboardOutline from '../../assets/icons/keyboard_outline.svg';
import knifeOutline from '../../assets/icons/knife_outline.svg';
import laptopOutline from '../../assets/icons/laptop_outline.svg';
import lifebuoyOutline from '../../assets/icons/lifebuoy_outline.svg';
import lightbulbOutline from '../../assets/icons/lightbulb_outline.svg';
import lightbulbStarOutline from '../../assets/icons/lightbulb_star_outline.svg';
import like from '../../assets/icons/like.svg';
import likeFilled from '../../assets/icons/like_filled.svg';
import likeLockOutline from '../../assets/icons/like_lock_outline.svg';
import linkCircleOutline from '../../assets/icons/link_circle_outline.svg';
import linkOutline from '../../assets/icons/link_outline.svg';
import linkedOutline from '../../assets/icons/linked_outline.svg';
import liquidaciones1 from '../../assets/icons/liquidaciones-1.svg';
import liquidaciones from '../../assets/icons/liquidaciones.svg';
import listAddOutline from '../../assets/icons/list_add_outline.svg';
import listCheckOutline from '../../assets/icons/list_check_outline.svg';
import listLikeOutline from '../../assets/icons/list_like_outline.svg';
import listLikeSlashOutline from '../../assets/icons/list_like_slash_outline.svg';
import listOutline from '../../assets/icons/list_outline.svg';
import liveAddOutline from '../../assets/icons/live_add_outline.svg';
import liveDisableOutline from '../../assets/icons/live_disable_outline.svg';
import liveOutline from '../../assets/icons/live_outline.svg';
import liveSlashOutline from '../../assets/icons/live_slash_outline.svg';
import locationMapOutline from '../../assets/icons/location_map_outline.svg';
import locationOutline from '../../assets/icons/location_outline.svg';
import lockOpenOutline from '../../assets/icons/lock_open_outline.svg';
import lockOutline from '../../assets/icons/lock_outline.svg';
import logoVkOutline from '../../assets/icons/logo_vk_outline.svg';
import { logo, isotipo } from '../../assets/icons/Logo';
import logout from '../../assets/icons/logout.svg';
import lotusOutline from '../../assets/icons/lotus_outline.svg';
import loudspeakerSlashOutline from '../../assets/icons/loudspeaker_slash_outline.svg';
import magicHatOutline from '../../assets/icons/magic_hat_outline.svg';
import magicWandOutline from '../../assets/icons/magic_wand_outline.svg';
import magnifierMinus from '../../assets/icons/magnifier_minus.svg';
import magnifierPlus from '../../assets/icons/magnifier_plus.svg';
import mailOutline from '../../assets/icons/mail_outline.svg';
import mailStackOutline from '../../assets/icons/mail_stack_outline.svg';
import marketAddBadgeOutline from '../../assets/icons/market_add_badge_outline.svg';
import marketLikeOutline from '../../assets/icons/market_like_outline.svg';
import marketOutline from '../../assets/icons/market_outline.svg';
import marketSlashOutline from '../../assets/icons/market_slash_outline.svg';
import masksOutline from '../../assets/icons/masks_outline.svg';
import megafonOutline from '../../assets/icons/megafon_outline.svg';
import mentionOutline from '../../assets/icons/mention_outline.svg';
import menuOutline from '../../assets/icons/menu_outline.svg';
import messageAddBadgeOutline from '../../assets/icons/message_add_badge_outline.svg';
import messageArrowRightOutline from '../../assets/icons/message_arrow_right_outline.svg';
import messageCheckOutline from '../../assets/icons/message_check_outline.svg';
import messageCrossOutline from '../../assets/icons/message_cross_outline.svg';
import messageForwardOutline from '../../assets/icons/message_forward_outline.svg';
import messageHeartOutline from '../../assets/icons/message_heart_outline.svg';
import messageOutline from '../../assets/icons/message_outline.svg';
import messageReplyOutline from '../../assets/icons/message_reply_outline.svg';
import messageUnreadOutline from '../../assets/icons/message_unread_outline.svg';
import messageUnreadTopOutline from '../../assets/icons/message_unread_top_outline.svg';
import messagesOutline from '../../assets/icons/messages_outline.svg';
import microphoneSlashOutline from '../../assets/icons/microphone_slash_outline.svg';
import microphoneVideocamOutline from '../../assets/icons/microphone_videocam_outline.svg';
import microphoneVideocamSlashOutline from '../../assets/icons/microphone_videocam_slash_outline.svg';
import minusOutline from '../../assets/icons/minus_outline.svg';
import { ReactComponent as monetization } from '../../assets/icons/monetization.svg';
import moneyCircleOutline from '../../assets/icons/money_circle_outline.svg';
import { ReactComponent as overdue } from '../../assets/icons/overdue.svg';
import moneyHistoryBackwardOutline from '../../assets/icons/money_history_backward_outline.svg';
import moneyRequestOutline from '../../assets/icons/money_request_outline.svg';
import moneySendOutline from '../../assets/icons/money_send_outline.svg';
import moneyTransferOutline from '../../assets/icons/money_transfer_outline.svg';
import moneyWadOutline from '../../assets/icons/money_wad_outline.svg';
import mortarOutline from '../../assets/icons/mortar_outline.svg';
import motorcycleOutline from '../../assets/icons/motorcycle_outline.svg';
import movieReelOutline from '../../assets/icons/movie_reel_outline.svg';
import movimientos from '../../assets/icons/movimientos.svg';
import musicMicOutline from '../../assets/icons/music_mic_outline.svg';
import musicOutline from '../../assets/icons/music_outline.svg';
import muteOutline from '../../assets/icons/mute_outline.svg';
import nameTagOutline from '../../assets/icons/name_tag_outline.svg';
import narrativeActiveOutline from '../../assets/icons/narrative_active_outline.svg';
import narrativeOutline from '../../assets/icons/narrative_outline.svg';
import newsfeedOutline from '../../assets/icons/newsfeed_outline.svg';
import noSmokingSignOutline from '../../assets/icons/no_smoking_sign_outline.svg';
import notebookAddBadgeOutline from '../../assets/icons/notebook_add_badge_outline.svg';
import notebookCheckOutline from '../../assets/icons/notebook_check_outline.svg';
import {
  NotificationAddOutlineIcon,
  NotificationCheckOutline,
  NotificationDisabledOutline,
  notificationOutline,
} from '../../assets/icons/notificationIcon';
import notificationSlashOutline from '../../assets/icons/notification_slash_outline.svg';
import notificationSubtractOutline from '../../assets/icons/notification_subtract_outline.svg';
import onOffOutline from '../../assets/icons/on_off_outline.svg';
import paintRollerOutline from '../../assets/icons/paint_roller_outline.svg';
import paletteOutline from '../../assets/icons/palette_outline.svg';
import pawOutline from '../../assets/icons/paw_outline.svg';
import paymentCardOutline from '../../assets/icons/payment_card_outline.svg';
import paymentCardVerticalOutline from '../../assets/icons/payment_card_vertical_outline.svg';
import paymentHandOutline from '../../assets/icons/payment_hand_outline.svg';
import paywaveOutline from '../../assets/icons/paywave_outline.svg';
import penKeyholeOutline from '../../assets/icons/pen_keyhole_outline.svg';
import penStackLockOutline from '../../assets/icons/pen_stack_lock_outline.svg';
import penStackOutline from '../../assets/icons/pen_stack_outline.svg';
import phoneAddOutline from '../../assets/icons/phone_add_outline.svg';
import phoneOutline from '../../assets/icons/phone_outline.svg';
import phoneWaveOutline from '../../assets/icons/phone_wave_outline.svg';
import photosStackOutline from '../../assets/icons/photos_stack_outline.svg';
import pictureInPicture16x9Outline from '../../assets/icons/picture_in_picture_16x9_outline.svg';
import pictureOutline from '../../assets/icons/picture_outline.svg';
import pillOutline from '../../assets/icons/pill_outline.svg';
import pinDotOutline from '../../assets/icons/pin_dot_outline.svg';
import pinDotSlashOutline from '../../assets/icons/pin_dot_slash_outline.svg';
import pinOutline from '../../assets/icons/pin_outline.svg';
import pinSlashOutline from '../../assets/icons/pin_slash_outline.svg';
import pincodeLockOutline from '../../assets/icons/pincode_lock_outline.svg';
import pincodeOutline from '../../assets/icons/pincode_outline.svg';
import placeOutline from '../../assets/icons/place_outline.svg';
import planeOutline from '../../assets/icons/plane_outline.svg';
import planesGobierno from '../../assets/icons/planes-gobierno.svg';
import playCards2Outline from '../../assets/icons/play_cards_2_outline.svg';
import playNextOutline from '../../assets/icons/play_next_outline.svg';
import playSpeedOutline from '../../assets/icons/play_speed_outline.svg';
import playlistOutline from '../../assets/icons/playlist_outline.svg';
import podcastOutline from '../../assets/icons/podcast_outline.svg';
import pollOutline from '../../assets/icons/poll_outline.svg';
import pollSquareOutline from '../../assets/icons/poll_square_outline.svg';
import powerSocketOutline from '../../assets/icons/power_socket_outline.svg';
import prestamos1 from '../../assets/icons/prestamos-1.svg';
import prestamos from '../../assets/icons/prestamos.svg';
import printerOutline from '../../assets/icons/printer_outline.svg';
import privacyOutline from '../../assets/icons/privacy_outline.svg';
import qrCode from '../../assets/icons/qr_code.svg';
import qrCodeOutline from '../../assets/icons/qr_code_outline.svg';
import questionOutline from '../../assets/icons/question_outline.svg';
import radiowavesLeftAndRightOutline from '../../assets/icons/radiowaves_left_and_right_outline.svg';
import recorderTapeOutline from '../../assets/icons/recorder_tape_outline.svg';
import { refreshOutline } from '../../assets/icons/RefreshOutline';
import removeCircleOutline from '../../assets/icons/remove_circle_outline.svg';
import repeat1Outline from '../../assets/icons/repeat_1_outline.svg';
import repeatOutline from '../../assets/icons/repeat_outline.svg';
import replay10Outline from '../../assets/icons/replay_10_outline.svg';
import { ReactComponent as replayOutline } from '../../assets/icons/replay_outline.svg';
import replyOutline from '../../assets/icons/reply_outline.svg';
import reportOutline from '../../assets/icons/report_outline.svg';
import reportes1 from '../../assets/icons/reportes-1.svg';
import { ReactComponent as reportes } from '../../assets/icons/reportes.svg';
import robotOutline from '../../assets/icons/robot_outline.svg';
import roubleBadgeOutline from '../../assets/icons/rouble_badge_outline.svg';
import rssFeedOutline from '../../assets/icons/rss_feed_outline.svg';
import rssVideoOutline from '../../assets/icons/rss_video_outline.svg';
import sadFaceOutline from '../../assets/icons/sad_face_outline.svg';
import scanViewfinderOutline from '../../assets/icons/scan_viewfinder_outline.svg';
import schoolOutline from '../../assets/icons/school_outline.svg';
import screenGridHorizon2LineOutline from '../../assets/icons/screen_grid_horizon_2_line_outline.svg';
import screenGridHorizonLineOutline from '../../assets/icons/screen_grid_horizon_line_outline.svg';
import screenGridTileOutline from '../../assets/icons/screen_grid_tile_outline.svg';
import screenGridVerticalLineOutline from '../../assets/icons/screen_grid_vertical_line_outline.svg';
import screencastOutline from '../../assets/icons/screencast_outline.svg';
import {
  search,
  searchEye,
  searchLikeFilledOutline,
  searchLikeOutline,
  searchOutline,
  searchSlashOutline,
} from '../../assets/icons/Search';
import servicesGibdd from '../../assets/icons/services_gibdd.svg';
import servicesOutline from '../../assets/icons/services_outline.svg';
import settings from '../../assets/icons/settings.svg';
import { settingsOutline } from '../../assets/icons/SettingsOutline';
import shareExternal from '../../assets/icons/share_external.svg';
import shareOutline from '../../assets/icons/share_outline.svg';
import shieldKeyholeOutline from '../../assets/icons/shield_keyhole_outline.svg';
import shoppingCartOutline from '../../assets/icons/shopping_cart_outline.svg';
import shuffleOutline from '../../assets/icons/shuffle_outline.svg';
import sinEspecificar from '../../assets/icons/sin-especificar.svg';
import skirtOutline from '../../assets/icons/skirt_outline.svg';
import skullOutline from '../../assets/icons/skull_outline.svg';
import slidersOutline from '../../assets/icons/sliders_outline.svg';
import smartphoneOutline from '../../assets/icons/smartphone_outline.svg';
import smileOutline from '../../assets/icons/smile_outline.svg';
import smiles2Outline from '../../assets/icons/smiles_2_outline.svg';
import sneakerOutline from '../../assets/icons/sneaker_outline.svg';
import snowflakeOutline from '../../assets/icons/snowflake_outline.svg';
import songOutline from '../../assets/icons/song_outline.svg';
import sortHorizontalOutline from '../../assets/icons/sort_horizontal_outline.svg';
import sortOutline from '../../assets/icons/sort_outline.svg';
import sparkleOutline from '../../assets/icons/sparkle_outline.svg';
import speedometerMaxOutline from '../../assets/icons/speedometer_max_outline.svg';
import speedometerMiddleOutline from '../../assets/icons/speedometer_middle_outline.svg';
import speedometerMinOutline from '../../assets/icons/speedometer_min_outline.svg';
import square4Outline from '../../assets/icons/square_4_outline.svg';
import starsOutline from '../../assets/icons/stars_outline.svg';
import statisticsOutline from '../../assets/icons/statistics_outline.svg';
import stickerOutline from '../../assets/icons/sticker_outline.svg';
import stopwatchOutline from '../../assets/icons/stopwatch_outline.svg';
import storefrontOutline from '../../assets/icons/storefront_outline.svg';
import storyAddOutline from '../../assets/icons/story_add_outline.svg';
import storyOutline from '../../assets/icons/story_outline.svg';
import studOutline from '../../assets/icons/stud_outline.svg';
import subtitlesOutline from '../../assets/icons/subtitles_outline.svg';
import sunOutline from '../../assets/icons/sun_outline.svg';
import successCircleFilled from '../../assets/icons/success_circle_filled.svg';
import switchOutline from '../../assets/icons/switch_outline.svg';
import syncOutline from '../../assets/icons/sync_outline.svg';
import tShirtOutline from '../../assets/icons/t-shirt_outline.svg';
import tagOutline from '../../assets/icons/tag_outline.svg';
import targetOutline from '../../assets/icons/target_outline.svg';
import tearOffFlyerOutline from '../../assets/icons/tear_off_flyer_outline.svg';
import terminales1 from '../../assets/icons/terminales-1.svg';
import terminales from '../../assets/icons/terminales.svg';
import textCircleOutline from '../../assets/icons/text_circle_outline.svg';
import textLiveOutline from '../../assets/icons/text_live_outline.svg';
import textOutline from '../../assets/icons/text_outline.svg';
import textTtOutline from '../../assets/icons/text_tt_outline.svg';
import thumbsUpOutline from '../../assets/icons/thumbs_up_outline.svg';
import ticketOutline from '../../assets/icons/ticket_outline.svg';
import touchIdOutline from '../../assets/icons/touch_id_outline.svg';
import trainOutline from '../../assets/icons/train_outline.svg';
import tshirtOutline from '../../assets/icons/tshirt_outline.svg';
import tvOutline from '../../assets/icons/tv_outline.svg';
import unarchiveOutline from '../../assets/icons/unarchive_outline.svg';
import unblockOutline from '../../assets/icons/unblock_outline.svg';
import unfavoriteOutline from '../../assets/icons/unfavorite_outline.svg';
import unpinOutline from '../../assets/icons/unpin_outline.svg';
import userAddOutline from '../../assets/icons/user_add_outline.svg';
import userAddedOutline from '../../assets/icons/user_added_outline.svg';
import userBackgroundOutline from '../../assets/icons/user_background_outline.svg';
import userCircleOutline from '../../assets/icons/user_circle_outline.svg';
import userIncomingOutline from '../../assets/icons/user_incoming_outline.svg';
import userMicrophoneBadgeOutline from '../../assets/icons/user_microphone_badge_outline.svg';
import userMicrophoneBadgeSlashOutline from '../../assets/icons/user_microphone_badge_slash_outline.svg';
import userOutgoingOutline from '../../assets/icons/user_outgoing_outline.svg';
import userSquareOutline from '../../assets/icons/user_square_outline.svg';
import userStarBadgeOutline from '../../assets/icons/user_star_badge_outline.svg';
import userStarBadgeSlashOutline from '../../assets/icons/user_star_badge_slash_outline.svg';
import userTagOutline from '../../assets/icons/user_tag_outline.svg';
import { ReactComponent as users3Outline } from '../../assets/icons/users_3_outline.svg';
import {
  usersOutline,
  userOutline,
  userAddBadgeOutline,
  usersGroup,
} from '../../assets/icons/UserIcon';
import videoCircleOutline from '../../assets/icons/video_circle_outline.svg';
import videoOutline from '../../assets/icons/video_outline.svg';
import videocamAddOutline from '../../assets/icons/videocam_add_outline.svg';
import videocamArrowUpOutline from '../../assets/icons/videocam_arrow_up_outline.svg';
import videocamArrowUpSlashOutline from '../../assets/icons/videocam_arrow_up_slash_outline.svg';
import videocamOutline from '../../assets/icons/videocam_outline.svg';
import videocamSlashOutline from '../../assets/icons/videocam_slash_outline.svg';
import vinylOutline from '../../assets/icons/vinyl_outline.svg';
import vmojiOutline from '../../assets/icons/vmoji_outline.svg';
import voiceOutline from '../../assets/icons/voice_outline.svg';
import volumeOutline from '../../assets/icons/volume_outline.svg';
import walletOutline from '../../assets/icons/wallet_outline.svg';
import warningCircleFilled from '../../assets/icons/warning_circle_filled.svg';
import washerOutline from '../../assets/icons/washer_outline.svg';
import waterDropOutline from '../../assets/icons/water_drop_outline.svg';
import wheelOutline from '../../assets/icons/wheel_outline.svg';
import windowCheck from '../../assets/icons/window_check.svg';
import workOutline from '../../assets/icons/work_outline.svg';
import wristWatchOutline from '../../assets/icons/wrist_watch_outline.svg';
import writeOutline from '../../assets/icons/write_outline.svg';
import writeSquareOutline from '../../assets/icons/write_square_outline.svg';
import zipOutline from '../../assets/icons/zip_outline.svg';
import terminalClasica from '../../assets/icons/terminal_clasica.svg';
import terminalSinEspecificar from '../../assets/icons/terminal_sin_especificar.svg';
import whatsapp from '../../assets/icons/whatsapp.svg';
import committeeOutline from '../../assets/icons/committee_outline.tsx';
import company from '../../assets/icons/company.tsx';
import instrumentationOutline from '../../assets/icons/instrumentation_outline.tsx';
import { group } from '../../assets/icons/Group';
import { bank } from '../../assets/icons/Bank';
import { moneyDollarBox } from '../../assets/icons/MoneyDollarBox';
import { moneyPesosBox } from '../../assets/icons/MoneyPesosBox';
import { plusIcon } from '../../assets/icons/PlusIcon';
import { protectorIcon } from '../../assets/icons/ProtectorIcon';
import { otherFilter } from '../../assets/icons/Other-filter.tsx'; 
import {
  partialOutline,
  doneOutline,
  editOutline,
  folderOutline,
  likeOutline,
  crossShieldOutline,
  homeOutline,
  deleteOutline,
  infoCircleOutline,
  dashboardOutline,
  checkCircleOutline,
  warningTriangleOutline,
  riskOutline,
  originationOutline,
  quillPenOutline,
  clockOutline,
} from '../../assets/icons/IconSVG';

import { chevronLeft, chevronRight } from '../../assets/icons/Chevron';

import {
  documentOutline,
  documentDownloadOutline,
  uploadCloudOutline,
  uploadOutline,
  downloadOutline,
  cloudOutline,
  sendOutline,
} from '../../assets/icons/UploadIcon';
import { moreHorizontal, moreVertical } from '../../assets/icons/More';
import { annexes } from '../../assets/icons/Annexes';
import { play } from '../../assets/icons/Play';

export type IconProps = {
  height: number;
  width: number;
};

const IconSource = {
  QR: qr,
  'puntos-venta': puntosVenta,
  accessibility_outline: accessibilityOutline,
  aceleraciones: aceleraciones,
  add_award_outline: addAwardOutline,
  add_awards_outline: addAwardsOutline,
  add_circle_dashed_outline: addCircleDashedOutline,
  add_circle_outline: addCircleOutline,
  add_outline: addOutline,
  add_square_outline: addSquareOutline,
  advertising_outline: advertisingOutline,
  'ahora-12': ahora12,
  'ahora-12-b': ahora12b,
  airplay_audio_outline: airplayAudioOutline,
  airplay_video_outline: airplayVideoOutline,
  all_categories_outline: allCategoriesOutline,
  anses: anses,
  app_badge_outline: appBadgeOutline,
  apple_outline: appleOutline,
  apple_watch_outlite: appleWatchOutlite,
  archive_outline: archiveOutline,
  armchair_outline: armchairOutline,
  arrow_down_outline: arrowDownOutline,
  arrow_left_outline: arrowLeftOutline,
  arrow_pop_down_outline: arrowPopDownOutline,
  arrow_pop_up_outline: arrowPopUpOutline,
  arrow_right_circle_outline: arrowRightCircleOutline,
  arrow_right_outline: arrowRightOutline,
  arrow_right_square_outline: arrowRightSquareOutline,
  arrow_up_circle_outline: arrowUpCircleOutline,
  arrow_up_outline: arrowUpOutline,
  arrow_up_rectangle_outline: arrowUpRectangleOutline,
  arrow_uturn_left_outline: arrowUturnLeftOutline,
  arrow_uturn_right_outline: arrowUturnRightOutline,
  article_outline: articleOutline,
  articles_outline: articlesOutline,
  attach_outline: attachOutline,
  baby_bottle_outline: babyBottleOutline,
  backspace_outline: backspaceOutline,
  ball_outline: ballOutline,
  bank_outline: bankOutline,
  basketball_ball_outline: basketballBallOutline,
  beauty_outline: beautyOutline,
  bidy_outline: bidyOutline,
  billhead_outline: billheadOutline,
  block_outline: blockOutline,
  body_outline: bodyOutline,
  bomb_outline: bombOutline,
  book_outline: bookOutline,
  bookmark_outline: bookmarkOutline,
  books_outline: booksOutline,
  'boton-de-pago': botonDePago,
  bowl_sticks_outline: bowlSticksOutline,
  box_heart_outline: boxHeartOutline,
  brain_outline: brainOutline,
  briefcase_outline: briefcaseOutline,
  broadcast_outline: broadcastOutline,
  brush_outline: brushOutline,
  bug_outline: bugOutline,
  building_outline: buildingOutline,
  bus_outline: busOutline,
  cactus_outline: cactusOutline,
  calendar_outline: calendarOutline,
  camera_outline: cameraOutline,
  camera_slash_outline: cameraSlashOutline,
  cancel_circle_outline: cancelCircleOutline,
  cancel_outline: cancelOutline,
  cancel_shield_outline: cancelShieldOutline,
  canister_outline: canisterOutline,
  car_outline: carOutline,
  cards_2_outline: cards2Outline,
  cash_out_outline: cashOutOutline,
  chain_outline: chainOutline,
  check_circle_device_outline: checkCircleDeviceOutline,
  check_circle_outline: checkCircleOutline,
  check_shield_device_outline: checkShieldDeviceOutline,
  check_shield_outline: checkShieldOutline,
  check_square_outline: checkSquareOutline,
  checks_outline: checksOutline,
  chef_hat_outline: chefHatOutline,
  chevron_down_outline: chevronDownOutline,
  chevron_down_small: chevronDownSmall,
  chevron_left: chevronLeft,
  chevron_right: chevronRight,
  chevron_left_outline: chevronLeftOutline,
  chevron_left_small: chevronLeftSmall,
  chevron_right_circle_outline: chevronRightCircleOutline,
  chevron_right_outline: chevronRightOutline,
  chevron_right_small: chevronRightSmall,
  chevron_up_outline: chevronUpOutline,
  chevron_up_small: chevronUpSmall,
  chevrons_2_left_outline: chevrons2LeftOutline,
  chevrons_2_right_outline: chevrons2RightOutline,
  clear_data_outline: clearDataOutline,
  clip_outline: clipOutline,
  clock_outline: clockOutline,
  clock_rectangle_stack_outline: clockRectangleStackOutline,
  cloud_outline: cloudOutline,
  'cobro-anticipado': cobroAnticipado,
  coffee_steam_outline: coffeeSteamOutline,
  colaboradores: colaboradores,
  comment_disable_outline: commentDisableOutline,
  comment_outline: commentOutline,
  compass_outline: compassOutline,
  computer_outline: computerOutline,
  conciliacion: conciliacion,
  configuracion: configuracion,
  'contracargos-1': contracargos1,
  contracargos: contracargos,
  cookie_outline: cookieOutline,
  copy_outline: copyOutline,
  crop: crop,
  cross_shield_outline: crossShieldOutline,
  crown_outline: crownOutline,
  cube_box_outline: cubeBoxOutline,
  cup_outline: cupOutline,
  'cupones-en-vuelo': cuponesEnVuelo,
  dashboard_outline: dashboardOutline,
  delete_arrow_up_outline: deleteArrowUpOutline,
  delete_outline: deleteOutline,
  devices_outline: devicesOutline,
  diamond_outline: diamondOutline,
  dice_1_outline: dice1Outline,
  dice_2_outline: dice2Outline,
  dice_3_outline: dice3Outline,
  dice_4_outline: dice4Outline,
  dice_5_outline: dice5Outline,
  dice_6_outline: dice6Outline,
  discount_outline: discountOutline,
  document_download_outline: documentDownloadOutline,
  document_outline: documentOutline,
  dollar_circle_outline: dollarCircleOutline,
  donate_outline: donateOutline,
  done_outline: doneOutline,
  door_arrow_left_outline: doorArrowLeftOutline,
  door_arrow_right_outline: doorArrowRightOutline,
  download_cancel_outline: downloadCancelOutline,
  download_check_outline: downloadCheckOutline,
  download_cloud_outline: downloadCloudOutline,
  download_outline: downloadOutline,
  drill_outline: drillOutline,
  edit_outline: editOutline,
  education_outline: educationOutline,
  emblem_outline: emblemOutline,
  employee_outline: employeeOutline,
  error_circle_filled: errorCircleFilled,
  error_circle_outline: errorCircleOutline,
  explicit_outline: explicitOutline,
  external_link_outline: externalLinkOutline,
  face_id_outline: faceIdOutline,
  face_recognition_outline: faceRecognitionOutline,
  favorite: favorite,
  favorite_filled: favoriteFilled,
  favorite_outline: favoriteOutline,
  film_strip_add_outline: filmStripAddOutline,
  film_strip_outline: filmStripOutline,
  fire_outline: fireOutline,
  folder_outline: folderOutline,
  fortune_wheel_outline: fortuneWheelOutline,
  forward_10_outline: forward10Outline,
  game_outline: gameOutline,
  gesture_outline: gestureOutline,
  ghost_outline: ghostOutline,
  ghost_simle_outline: ghostSimleOutline,
  gift_outline: giftOutline,
  globe_outline: globeOutline,
  google_play_outline: googlePlayOutline,
  graph_outline: graphOutline,
  calculator_outline: calculatorOutline,
  grid_layout_outline: gridLayoutOutline,
  gun_outline: gunOutline,
  hammer_outline: hammerOutline,
  hand_slash_outline: handSlashOutline,
  hanger_outline: hangerOutline,
  hashtag_outline: hashtagOutline,
  headphones_outline: headphonesOutline,
  health_outline: healthOutline,
  heart_circle_outline: heartCircleOutline,
  heart_lock_outline: heartLockOutline,
  heart_unlock_outline: heartUnlockOutline,
  help_circle_outline: helpCircleOutline,
  help_outline: helpOutline,
  hide_outline: hideOutline,
  'historial-btn-pago': historialBtnPago,
  historial: historial,
  'history_backward_outline-1': historyBackwardOutline1,
  history_backward_outline: historyBackwardOutline,
  history_forward_outline: historyForwardOutline,
  home_heart_outline: homeHeartOutline,
  home_outline: homeOutline,
  horse_toy_outline: horseToyOutline,
  image_filter_outline: imageFilterOutline,
  inbox_outline: inboxOutline,
  incognito_outline: incognitoOutline,
  info_circle_outline: infoCircleOutline,
  informacion: informacion,
  inicio: inicio,
  'insumo-papel': insumoPapel,
  ipad_outline: ipadOutline,
  isotipo: isotipo,
  key_outline: keyOutline,
  key_square_outline: keySquareOutline,
  keyboard_bots_outline: keyboardBotsOutline,
  keyboard_outline: keyboardOutline,
  knife_outline: knifeOutline,
  laptop_outline: laptopOutline,
  lifebuoy_outline: lifebuoyOutline,
  lightbulb_outline: lightbulbOutline,
  lightbulb_star_outline: lightbulbStarOutline,
  like: like,
  like_filled: likeFilled,
  like_lock_outline: likeLockOutline,
  like_outline: likeOutline,
  link_circle_outline: linkCircleOutline,
  link_outline: linkOutline,
  linked_outline: linkedOutline,
  'liquidaciones-1': liquidaciones1,
  liquidaciones: liquidaciones,
  list_add_outline: listAddOutline,
  list_check_outline: listCheckOutline,
  list_like_outline: listLikeOutline,
  list_like_slash_outline: listLikeSlashOutline,
  list_outline: listOutline,
  live_add_outline: liveAddOutline,
  live_disable_outline: liveDisableOutline,
  live_outline: liveOutline,
  live_slash_outline: liveSlashOutline,
  location_map_outline: locationMapOutline,
  location_outline: locationOutline,
  lock_open_outline: lockOpenOutline,
  lock_outline: lockOutline,
  logo_vk_outline: logoVkOutline,
  logo: logo,
  logout: logout,
  lotus_outline: lotusOutline,
  loudspeaker_slash_outline: loudspeakerSlashOutline,
  magic_hat_outline: magicHatOutline,
  magic_wand_outline: magicWandOutline,
  magnifier_minus: magnifierMinus,
  magnifier_plus: magnifierPlus,
  mail_outline: mailOutline,
  mail_stack_outline: mailStackOutline,
  market_add_badge_outline: marketAddBadgeOutline,
  market_like_outline: marketLikeOutline,
  market_outline: marketOutline,
  market_slash_outline: marketSlashOutline,
  masks_outline: masksOutline,
  megafon_outline: megafonOutline,
  mention_outline: mentionOutline,
  menu_outline: menuOutline,
  message_add_badge_outline: messageAddBadgeOutline,
  message_arrow_right_outline: messageArrowRightOutline,
  message_check_outline: messageCheckOutline,
  message_cross_outline: messageCrossOutline,
  message_forward_outline: messageForwardOutline,
  message_heart_outline: messageHeartOutline,
  message_outline: messageOutline,
  message_reply_outline: messageReplyOutline,
  message_unread_outline: messageUnreadOutline,
  message_unread_top_outline: messageUnreadTopOutline,
  messages_outline: messagesOutline,
  microphone_slash_outline: microphoneSlashOutline,
  microphone_videocam_outline: microphoneVideocamOutline,
  microphone_videocam_slash_outline: microphoneVideocamSlashOutline,
  minus_outline: minusOutline,
  monetization: monetization,
  money_circle_outline: moneyCircleOutline,
  money_history_backward_outline: moneyHistoryBackwardOutline,
  money_request_outline: moneyRequestOutline,
  money_send_outline: moneySendOutline,
  money_transfer_outline: moneyTransferOutline,
  money_wad_outline: moneyWadOutline,
  more_horizontal: moreHorizontal,
  more_vertical: moreVertical,
  mortar_outline: mortarOutline,
  motorcycle_outline: motorcycleOutline,
  movie_reel_outline: movieReelOutline,
  movimientos: movimientos,
  music_mic_outline: musicMicOutline,
  music_outline: musicOutline,
  mute_outline: muteOutline,
  name_tag_outline: nameTagOutline,
  narrative_active_outline: narrativeActiveOutline,
  narrative_outline: narrativeOutline,
  newsfeed_outline: newsfeedOutline,
  no_smoking_sign_outline: noSmokingSignOutline,
  notebook_add_badge_outline: notebookAddBadgeOutline,
  notebook_check_outline: notebookCheckOutline,
  notification_add_outline: NotificationAddOutlineIcon,
  notification_check_outline: NotificationCheckOutline,
  notification_disable_outline: NotificationDisabledOutline,
  notification_outline: notificationOutline,
  notification_slash_outline: notificationSlashOutline,
  notification_subtract_outline: notificationSubtractOutline,
  on_off_outline: onOffOutline,
  origination_outline: originationOutline,
  overdue: overdue,
  paint_roller_outline: paintRollerOutline,
  palette_outline: paletteOutline,
  parcial_outline: partialOutline,
  paw_outline: pawOutline,
  payment_card_outline: paymentCardOutline,
  payment_card_vertical_outline: paymentCardVerticalOutline,
  payment_hand_outline: paymentHandOutline,
  paywave_outline: paywaveOutline,
  pen_keyhole_outline: penKeyholeOutline,
  pen_stack_lock_outline: penStackLockOutline,
  pen_stack_outline: penStackOutline,
  phone_add_outline: phoneAddOutline,
  phone_outline: phoneOutline,
  phone_wave_outline: phoneWaveOutline,
  photos_stack_outline: photosStackOutline,
  picture_in_picture_16x9_outline: pictureInPicture16x9Outline,
  picture_outline: pictureOutline,
  pill_outline: pillOutline,
  pin_dot_outline: pinDotOutline,
  pin_dot_slash_outline: pinDotSlashOutline,
  pin_outline: pinOutline,
  pin_slash_outline: pinSlashOutline,
  pincode_lock_outline: pincodeLockOutline,
  pincode_outline: pincodeOutline,
  place_outline: placeOutline,
  plane_outline: planeOutline,
  'planes-gobierno': planesGobierno,
  plus_icon: plusIcon,
  play_cards_2_outline: playCards2Outline,
  play_next_outline: playNextOutline,
  play_speed_outline: playSpeedOutline,
  playlist_outline: playlistOutline,
  podcast_outline: podcastOutline,
  poll_outline: pollOutline,
  poll_square_outline: pollSquareOutline,
  power_socket_outline: powerSocketOutline,
  'prestamos-1': prestamos1,
  prestamos: prestamos,
  printer_outline: printerOutline,
  privacy_outline: privacyOutline,
  qr_code: qrCode,
  qr_code_outline: qrCodeOutline,
  question_outline: questionOutline,
  radiowaves_left_and_right_outline: radiowavesLeftAndRightOutline,
  recorder_tape_outline: recorderTapeOutline,
  refresh_outline: refreshOutline,
  remove_circle_outline: removeCircleOutline,
  repeat_1_outline: repeat1Outline,
  repeat_outline: repeatOutline,
  replay_10_outline: replay10Outline,
  replay_outline: replayOutline,
  reply_outline: replyOutline,
  report_outline: reportOutline,
  'reportes-1': reportes1,
  reportes: reportes,
  risk_outline: riskOutline,
  robot_outline: robotOutline,
  rouble_badge_outline: roubleBadgeOutline,
  rss_feed_outline: rssFeedOutline,
  rss_video_outline: rssVideoOutline,
  sad_face_outline: sadFaceOutline,
  scan_viewfinder_outline: scanViewfinderOutline,
  school_outline: schoolOutline,
  screen_grid_horizon_2_line_outline: screenGridHorizon2LineOutline,
  screen_grid_horizon_line_outline: screenGridHorizonLineOutline,
  screen_grid_tile_outline: screenGridTileOutline,
  screen_grid_vertical_line_outline: screenGridVerticalLineOutline,
  screencast_outline: screencastOutline,
  search: search,
  search_eye: searchEye,
  search_like_filled_outline: searchLikeFilledOutline,
  search_like_outline: searchLikeOutline,
  search_outline: searchOutline,
  search_slash_outline: searchSlashOutline,
  send_outline: sendOutline,
  services_gibdd: servicesGibdd,
  services_outline: servicesOutline,
  settings: settings,
  settings_outline: settingsOutline,
  share_external: shareExternal,
  share_outline: shareOutline,
  shield_keyhole_outline: shieldKeyholeOutline,
  shopping_cart_outline: shoppingCartOutline,
  shuffle_outline: shuffleOutline,
  'sin-especificar': sinEspecificar,
  skirt_outline: skirtOutline,
  skull_outline: skullOutline,
  sliders_outline: slidersOutline,
  smartphone_outline: smartphoneOutline,
  smile_outline: smileOutline,
  smiles_2_outline: smiles2Outline,
  sneaker_outline: sneakerOutline,
  snowflake_outline: snowflakeOutline,
  song_outline: songOutline,
  sort_horizontal_outline: sortHorizontalOutline,
  sort_outline: sortOutline,
  sparkle_outline: sparkleOutline,
  speedometer_max_outline: speedometerMaxOutline,
  speedometer_middle_outline: speedometerMiddleOutline,
  speedometer_min_outline: speedometerMinOutline,
  square_4_outline: square4Outline,
  stars_outline: starsOutline,
  statistics_outline: statisticsOutline,
  sticker_outline: stickerOutline,
  stopwatch_outline: stopwatchOutline,
  storefront_outline: storefrontOutline,
  story_add_outline: storyAddOutline,
  story_outline: storyOutline,
  stud_outline: studOutline,
  subtitles_outline: subtitlesOutline,
  sun_outline: sunOutline,
  success_circle_filled: successCircleFilled,
  switch_outline: switchOutline,
  sync_outline: syncOutline,
  't-shirt_outline': tShirtOutline,
  tag_outline: tagOutline,
  target_outline: targetOutline,
  tear_off_flyer_outline: tearOffFlyerOutline,
  'terminales-1': terminales1,
  terminales: terminales,
  text_circle_outline: textCircleOutline,
  text_live_outline: textLiveOutline,
  text_outline: textOutline,
  text_tt_outline: textTtOutline,
  thumbs_up_outline: thumbsUpOutline,
  ticket_outline: ticketOutline,
  touch_id_outline: touchIdOutline,
  train_outline: trainOutline,
  tshirt_outline: tshirtOutline,
  tv_outline: tvOutline,
  unarchive_outline: unarchiveOutline,
  unblock_outline: unblockOutline,
  unfavorite_outline: unfavoriteOutline,
  unpin_outline: unpinOutline,
  upload_outline: uploadOutline,
  user_add_badge_outline: userAddBadgeOutline,
  user_add_outline: userAddOutline,
  user_added_outline: userAddedOutline,
  user_background_outline: userBackgroundOutline,
  user_circle_outline: userCircleOutline,
  user_incoming_outline: userIncomingOutline,
  user_microphone_badge_outline: userMicrophoneBadgeOutline,
  user_microphone_badge_slash_outline: userMicrophoneBadgeSlashOutline,
  user_outgoing_outline: userOutgoingOutline,
  user_outline: userOutline,
  user_square_outline: userSquareOutline,
  user_star_badge_outline: userStarBadgeOutline,
  user_star_badge_slash_outline: userStarBadgeSlashOutline,
  user_tag_outline: userTagOutline,
  users_3_outline: users3Outline,
  users_outline: usersOutline,
  users_group: usersGroup,
  video_circle_outline: videoCircleOutline,
  video_outline: videoOutline,
  videocam_add_outline: videocamAddOutline,
  videocam_arrow_up_outline: videocamArrowUpOutline,
  videocam_arrow_up_slash_outline: videocamArrowUpSlashOutline,
  videocam_outline: videocamOutline,
  videocam_slash_outline: videocamSlashOutline,
  view_outline: viewOutline,
  vinyl_outline: vinylOutline,
  vmoji_outline: vmojiOutline,
  voice_outline: voiceOutline,
  volume_outline: volumeOutline,
  wallet_outline: walletOutline,
  warning_triangle_outline: warningTriangleOutline,
  warning_circle_filled: warningCircleFilled,
  washer_outline: washerOutline,
  water_drop_outline: waterDropOutline,
  wheel_outline: wheelOutline,
  window_check: windowCheck,
  work_outline: workOutline,
  wrist_watch_outline: wristWatchOutline,
  write_outline: writeOutline,
  write_square_outline: writeSquareOutline,
  zip_outline: zipOutline,
  terminal_clasica: terminalClasica,
  terminal_sin_especificar: terminalSinEspecificar,
  upload_cloud_outline: uploadCloudOutline,
  whatsapp: whatsapp,
  committee_outline: committeeOutline,
  company: company,
  instrumentation_outline: instrumentationOutline,
  quill_pen_outline: quillPenOutline,
  group: group,
  bank: bank,
  moneyDollarBox: moneyDollarBox,
  moneyPesosBox: moneyPesosBox,
  annexes: annexes,
  play: play,
  other_filter: otherFilter,
  protector_icon: protectorIcon,
};

export default IconSource;
